import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { TourDirectionCard } from 'pages/tours/components/tour-direction-card'
import { useTourDirections } from 'pages/tours/lib/use-tour-directions'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const AllDirectionsPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { directions, isLoading, isError, requestDirections, selectDirection } =
    useTourDirections()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className={s.page}>
      <HeaderGoBack
        buttonWhite
        variant="grey"
        title={t('tours_block.directions.title')}
        onGoBack={() => navigate(-1)}
      />

      {isLoading ? (
        <ul className={s.grid}>
          {Array.from({ length: 8 }).map((_, index) => (
            <li
              key={index}
              className={s.card}
            >
              <Skeleton className={s.skeleton} />
            </li>
          ))}
        </ul>
      ) : isError ? (
        <div className={s.state}>
          <p className="medium-14">{t('tours_block.directions.load_error')}</p>
          <button
            type="button"
            className={clsx('medium-14', s.retry)}
            onClick={() => void requestDirections()}
          >
            {t('tours_block.directions.retry')}
          </button>
        </div>
      ) : directions.length ? (
        <ul className={s.grid}>
          {directions.map((direction) => (
            <li
              key={direction.destination_country.id}
              className={s.card}
            >
              <TourDirectionCard
                direction={direction}
                onClick={() => selectDirection(direction)}
              />
            </li>
          ))}
        </ul>
      ) : (
        <p className={clsx('medium-14', s.state)}>
          {t('tours_block.directions.unavailable')}
        </p>
      )}
    </main>
  )
})

export default AllDirectionsPage
